import { render, staticRenderFns } from "./AddTagModal.vue?vue&type=template&id=3eb0bed1&"
import script from "./AddTagModal.vue?vue&type=script&lang=js&"
export * from "./AddTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports